import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HC_SERVICES } from "../../data/hcServicesData";
import Hero from "../../components/medical/Hero";
import ServiceDetailContent from "../../components/ServiceDetailContent";
import Footer from "../../components/Footer";

/** Pathname to service id (from HC_SERVICES) */
const PATH_TO_SERVICE_ID = {
  "/medical/suchmethode": "suchmethode",
  "/medical/executive-search": "executive-search",
  "/medical/praxisnachfolger-suche": "praxisnachfolger",
  "/medical/garantien": "garantien",
};

export default function ServiceDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const serviceId = PATH_TO_SERVICE_ID[location.pathname];
  const service = serviceId
    ? HC_SERVICES.find((s) => s.id === serviceId)
    : null;

  if (!service) {
    return (
      <div className="container-app py-16 text-center">
        <p className="text-gray-600">Seite nicht gefunden.</p>
        <button
          type="button"
          onClick={() => navigate("/medical")}
          className="mt-4 text-gray-900 underline"
        >
          Zur Startseite
        </button>
      </div>
    );
  }

  return (
    <>
      <Hero title={service.title} subheading={service.heroSubheading} />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        <ServiceDetailContent
          service={service}
          onClose={() => navigate(-1)}
          sectionIdPrefix="service"
        />
      </section>
      <Footer />
    </>
  );
}
